import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const baseService = createCrudService("vr_activities", [], router);

export const vrActivitiesService = {
  ...baseService,
  // Active (non-archived) activities for a single service code, ordered.
  listByServiceCode: (code) =>
    api.getCall("/api/vr_activities", { service_code: code }),
  // Includes archived rows — used by the admin management screen.
  listAllByServiceCode: (code) =>
    api.getCall("/api/vr_activities", {
      service_code: code,
      include_archived: "true",
    }),
  // Persist a new display order; ids is the full ordered list.
  reorder: (ids) => api.putCall("/api/vr_activities/reorder", { ids }),
};
